// eslint-disable-next-line no-unused-vars
import React from 'react';
import { IconMembership, dlsBrightBlue } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars
import { routes } from '../../constants/paths';
import labels from '../../constants/labels';

export const digitalAssetsActions = {
  fxAccount: {
    id: 'sftUser-digital-asset',
    heading: labels.FX_ACCOUNT,
    icon: <IconMembership size="lg" theme={dlsBrightBlue} className="pad-1-t" />,
    primaryButtonLabel: labels.GET_STARTED,
    tertiaryButtonLabel: labels.LEARN_MORE,
    modalProp: {
      modalId: 'modal-sftUser-digital-asset',
      modalHeader: labels.FX_ACCOUNT,
      modalBody: (
        <>
          <p>
            Click the button below to update the password used to transfer files with American Express. You can update
            your password directly from this page or if you received a notification to update your password you can
            follow the link provided in the message. If your password is contained in your local file transfer client,
            your administrator will need to change the password in the file transfer client and you will provide that
            same password at the link below.
          </p>
          <br />
          <p>The updating of this password ensures your access to American Express for file transfers.</p>
          <ul>
            <li>View the security standard informing this action</li>
            <li>View instructions on how to update your password</li>
          </ul>
          <br />
          <br />
        </>
      ),
    },
    componentPath: routes.manageDigitalAssetsSftUser,
  },
};

export const pageInstructions = [
  { instructionId: 'manage-sft-user', instructionName: 'How do I manage my SFT User?', instructionLink: '#Link2' },
];
